import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {RarityConfig} from "@/modules/redactor/models/rarity/RarityConfig";

export class ItemOfferConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemOfferConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemOfferConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._offer = null;
        this._rarity = [];
        this._mergeLength = 0;

    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    get offer() {
        return this._offer;
    }

    set offer(value) {
        this._offer = value;
    }

    get mergeLength() {
        return this._mergeLength;
    }

    set mergeLength(value) {
        this._mergeLength = value;
    }


    valid() {

        if (this.rarity && this.rarity.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.offer || !RedactorUtils.getItemOffer(this.offer)) {
            return false;
        }

        if (!Number.isInteger(this.mergeLength) || this.mergeLength < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.offer;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemOfferConfig());
        } else if (target instanceof ItemOfferConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemOfferConfig, {
    _offer: alias("offer", Schema.primitive()),
    _rarity: alias("rarity", list(RarityConfig.schema())),
    _mergeLength: alias("merge_length", Schema.primitive())
});